import React from "react";
import styled from "styled-components";

const Select = styled.select`
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  &:focus {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
  }
  appearance: none; /* standard */
  -webkit-appearance: none; /* Chrome/Safari */
  -moz-appearance: none; /* Firefox */
  padding-right: 30px;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M5 7l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 15px;
`;

export default Select;
